<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${$style.dialogStoreJtails} isStyleFull ${$globalIsDingBeauty ? $style.isStyleDingBeauty : ''} `"
    width="100vw"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div v-show="step === 0" class="container">
      <div class="mb-5 d-flex justify-content-between">
        <div v-if="$globalIsDingBeauty" class="dialogStoreJtails__title isStyleStep1">
          <span class="fs-sm ls-0">COURSE</span>
          <div>護理課程</div>
        </div>
        <el-select v-model="cityArea" clearable placeholder="所有地區" :class="{ 'isStyleDingBeauty isUnderLine isDarkMode': $globalIsDingBeauty }">
          <el-option v-for="(cityAreaItem, $index) in cityAreaList" :key="$index" :label="cityAreaItem.text" :value="cityAreaItem.value"> </el-option>
        </el-select>
      </div>
      <ul :class="[$style.areaList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
        <template v-for="(cityAreaItem, index) in currentCityAreaList">
          <li v-if="!!storeOptionsList(cityAreaItem.value)[0]" :key="`cityAreaList-${index}`" class="areaList__item">
            <div class="areaList__title">
              {{ cityAreaItem.text }}
            </div>
            <ul :class="[$style.storeList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]" class="row">
              <li
                v-for="(storeItem, index2) in storeOptionsList(cityAreaItem.value)"
                :key="`storeList-${index}-${index2}`"
                class="storeList__item col-md-6 col-lg-4 col-xl-3"
                @click="selectStore(storeItem, cityAreaItem)"
              >
                <div class="storeList__imageBox">
                  <div class="storeList__image">
                    <div class="storeList__imageInner" :style="{ backgroundImage: `url('${getDefaultImage(storeItem.images) || require('@assets/images/default/store-default-Image@2x.png')}')` }">
                    </div>
                  </div>
                </div>
                <div class="storeList__contentBox">
                  <div class="storeList__title">
                    {{ storeItem.title }}
                  </div>
                  <div v-if="storeItem.storeType === 'store'" class="storeList__address">
                    {{ storeItem.fullAddress }}
                  </div>
                  <div v-if="!$globalIsDingBeauty" class="mt-2">
                    <el-tag class="isStylePrimary isSmall2 mr-2"> 寵物美容 </el-tag>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </template>
      </ul>
    </div>
    <div v-show="step === 1" class="container">
      <div class="dialogStoreJtails__step1">
        <div v-if="$globalIsDingBeauty" class="dialogStoreJtails__title isStyleStep1">
          <span class="fs-sm ls-0">COURSE</span>
          <div>護理課程</div>
        </div>
        <ul :class="[$style.areaList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
          <li class="areaList__item">
            <div class="areaList__titleBox d-md-flex justify-content-between">
              <div class="areaList__title">
                {{ tempStore.city + tempStore.title }}
              </div>
              <div>
                沒有出現想預約的美容師嗎？
                <BaseButton
                  class="isStylePrimary isTextUnderline"
                  @click="
                    step = 0
                    tempStore = {}
                  "
                  >換間分店試試
                </BaseButton>
              </div>
            </div>
            <ul class="row" :class="[$style.scheduleItems, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
              <li v-for="(scheduleItem, $index2) in scheduleItems" :key="`scheduleItems-${$index2}`" class="scheduleItems__item" @click="goToReservation(scheduleItem)">
                <div class="scheduleItems__imageBox">
                  <div class="scheduleItems__image">
                    <div class="scheduleItems__imageInner" :style="{ backgroundImage: `url('${scheduleItem.avatar || require('@assets/images/reservation/person_background.svg')}')` }"> </div>
                  </div>
                </div>
                <div class="scheduleItems__contentBox">
                  <div class="scheduleItems__name Jost">
                    {{ scheduleItem.name }}
                    <BaseButton v-if="scheduleItem.id !== ''" class="isStylePrimary isText3" @click.stop="openDialogScheduleItem(scheduleItem)">
                      <FontAwesomeIcon icon="fa-regular fa-eye" />
                    </BaseButton>
                  </div>
                  <div class="scheduleItems__title mt-1">
                    {{ scheduleItem.title }}
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dialog2Mixin from '../mixins/dialog2'
import { cityAreaOptions, storeOptions } from '@utils/ipetbooking-options'
import { conditionList } from '@utils/is-condition'
import formatTextUpperCasefirst from '@utils/format-text-upper-casefirst'
import { merchantComputed } from '@store/helpers'

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      cityAreaList: cityAreaOptions(),
      cityArea: '',
      activeTab: 'store',
      storeOpenStoreOptions: Object.freeze(
        storeOptions({
          type: 'open',
          storeType: 'store',
        })
      ),
      storeOpenHomeOptions: Object.freeze(
        storeOptions({
          type: 'open',
          storeType: 'home',
        })
      ),
      tempStore: {},
      step: 0,
    }
  },
  computed: {
    ...merchantComputed,
    scheduleItems() {
      if (Object.keys(this.tempStore).length > 0) {
        const normalArr = [
          ...this.tempStore?.scheduleItems.filter((item) => {
            return item.types.includes('cosmetic')
          }),
        ]
        if (this.$globalIsShowRandomScheduleItem) {
          normalArr.unshift({
            id: '',
            name: '不指定',
            title: '不指定美容師',
            avatar: require(`@assets/images/${this.$globalProjectName}/reservation/person.svg`),
          })
        }
        return normalArr
      } else {
        return []
      }
    },
    tabList() {
      return conditionList([
        {
          title: '店面服務',
          name: 'store',
          condition: () => {
            return true
          },
        },
      ])
    },
    currentCityAreaList() {
      if (this.cityArea === '') {
        return this.cityAreaList
      } else {
        return this.cityAreaList.filter((item) => {
          return item.value === this.cityArea
        })
      }
    },
  },
  methods: {
    storeOptions() {
      return this[`storeOpen${formatTextUpperCasefirst(this.activeTab)}Options`]
    },
    getDefaultImage(images) {
      const defaultImageItems = images.filter((image) => image.default) || []

      return defaultImageItems[0]?.path || ''
    },
    selectStore(storeItem, cityAreaItem) {
      if (this.currentMerchant.cosmeticSetting.canSpecifyScheduleItem) {
        this.tempStore = storeItem
        this.step = 1
      } else {
        this.$router.push({
          name: 'store',
          params: {
            storeAlias: storeItem.alias,
          },
        })
        this.dialog2MixinVisible = false
      }
    },
    storeOptionsList(storeArea) {
      return storeOptions({
        storeArea,
        storeList: this.activeTab === 'store' ? this.storeOpenStoreOptions : this.storeOpenHomeOptions,
      })
    },
    openDialogScheduleItem(item) {
      this.$globalDialog('DialogScheduleItem', {
        ...item,
      })
    },
    goToReservation(scheduleItems) {
      this.$router.push({
        name: 'store',
        params: {
          storeAlias: this.tempStore.alias,
        },
        query: {
          scheduleItemId: scheduleItems.id ?? undefined,
        },
      })
      this.dialog2MixinVisible = false
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.dialogStoreJtails {
  position: relative;
  background-image: linear-gradient(to right, rgba($color-primary, 0.1), rgba($color-primary, 0.1)), url('@assets/images/layout/bg-marble.jpg') !important;
  background-position: center !important;
  background-size: cover !important;

  &::before {
    position: absolute;
    top: 1rem;
    left: calc(((100vw - #{$container}) / 2) - 200px);
    width: 283px;
    height: 310px;
    content: '';
    background-image: url('@assets/images/layout/logo-jtails-small-green.svg');
    background-position: center;
    background-size: cover;
    opacity: 0.15;

    @media (max-width: #{$container + 450px}) {
      left: 1rem;
    }

    @include max-sm {
      display: none;
    }
  }

  :global {
    .dialogStoreJtails {
      @include unstyled;

      &__title {
        margin-bottom: 2.5rem;
        font-family: $font-serif;
        font-size: 1.25rem;
        letter-spacing: 0.2em;

        &.isStyleStep1 {
          width: 95%;

          @include max-xl {
            width: 91%;
          }

          margin-left: auto;
          margin-right: auto;
        }
      }

      &__step1 {
        margin-left: -2.5%;
        margin-right: -2.5%;

        @include max-xl {
          margin-left: -4.5%;
          margin-right: -4.5%;
        }
      }
    }

    // stylelint-disable-next-line selector-class-pattern
    .el-dialog {
      &__body {
        padding-top: 9.375rem !important;

        @include max-md {
          padding-top: 4rem !important;
        }
      }
    }
  }

  &.isStyleDingBeauty {
    background-image: none !important;
    background-color: rgba($color: $color-secondary, $alpha: 0.9);

    &::before {
      display: none;
    }

    :global {
      .dialogStoreJtails {
        &__title {
          color: #fff;
        }
      }
    }
  }
}

.areaList {
  @include list-unstyled;

  :global {
    .areaList {
      &__item {
        &:not(:last-child) {
          margin-bottom: 3rem;
        }
      }

      &__titleBox {
        width: 95%;

        @include max-xl {
          width: 91%;
        }

        margin: 0 auto;
      }

      &__title {
        margin-bottom: 2.5rem;
        font-family: $font-serif;
        font-size: 1.25rem;
        letter-spacing: 0.2em;
      }
    }
  }

  &.isStyleDingBeauty {
    :global {
      .areaList {
        &__title {
          color: #fff;
        }

        &__titleBox {
          color: #fff;
        }
      }
    }
  }
}

.storeList {
  @include list-unstyled;

  :global {
    .storeList {
      &__item {
        display: flex;
        flex-direction: column;

        @include max-sm {
          flex-direction: row;
          align-items: center;
        }

        &:not(:last-child) {
          margin-bottom: 1.5rem;
        }
      }

      &__imageBox {
        width: 100%;

        @include max-sm {
          flex-shrink: 0;
          width: 150px;
        }
      }

      &__image {
        position: relative;
        display: block;
        padding-top: 56.5%;
        margin-bottom: 0.75rem;
        overflow: hidden;

        @include max-sm {
          margin-bottom: 0;
        }
      }

      &__imageInner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);
        cursor: pointer;

        &:hover {
          transform: scale(1.15);
        }
      }

      &__contentBox {
        @include max-sm {
          padding-left: 1rem;
        }
      }

      &__title {
        margin-bottom: 0.25rem;
        font-family: $font-serif;
        font-weight: 600;
        color: #3f3a2e;
        letter-spacing: 0.2em;
        cursor: pointer;

        &:hover {
          color: $color-primary;
        }
      }

      &__address {
        font-size: 0.75rem;
        color: #726f65;
      }
    }
  }

  &.isStyleDingBeauty {
    :global {
      .storeList {
        &__title {
          color: #fff;
        }

        &__address {
          color: #fff;
        }
      }
    }
  }
}

.scheduleItems {
  @include list-unstyled;

  @include max-md {
    margin-top: 2rem !important;
  }

  :global {
    .scheduleItems {
      &__item {
        flex: 0 0 auto;
        width: 20%;
        margin-bottom: 3rem;

        @include max-xl {
          width: 25%;
        }

        @include max-lg {
          width: 33.3333333%;
        }

        @include max-md {
          width: 50%;
        }

        display: flex;
        flex-direction: column;

        @include max-sm {
          // flex-direction: row;
          // align-items: center;
          margin-bottom: 1.5rem;
        }
      }

      &__imageBox {
        width: 100%;

        @include max-sm {
          flex-shrink: 0;
          // width: 150px;
        }
      }

      &__image {
        position: relative;
        display: block;
        border-radius: 100%;
        margin-bottom: 0.75rem;
        overflow: hidden;
        border-radius: 100%;
        width: 170px;
        height: 170px;
        margin: 0 auto;

        @include max-md {
          width: 130px;
          height: 130px;
        }

        @include max-sm {
          margin-bottom: 0;
        }
      }

      &__imageInner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #fff;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);
        cursor: pointer;

        &:hover {
          transform: scale(1.15);
        }
      }

      &__contentBox {
        text-align: center;
        margin-top: 1rem;

        @include max-md {
          padding-left: 0;
        }
      }

      &__name {
        margin-bottom: 0.25rem;
        font-family: $font-serif;
        font-weight: 600;
        color: #3f3a2e;
        letter-spacing: 0.2em;
        cursor: pointer;

        &:hover {
          color: $color-primary;
        }
      }

      &__title {
        color: #726f65;
      }
    }
  }

  &.isStyleDingBeauty {
    :global {
      .scheduleItems {
        &__imageInner {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: #fff;
          background-position: center;
          background-size: cover;
          transition: transform 0.3s;
          transform: scale(1);
          cursor: pointer;

          &:hover {
            transform: scale(1.15);
          }
        }

        &__contentBox {
          text-align: center;
          margin-top: 1rem;
          // @include max-sm {
          //   padding-left: 1rem;
          // }
        }

        &__title {
          color: #fff;
        }

        &__name {
          color: #fff;

          &:hover {
            color: rgb(#fff, 0.9);
          }
        }
      }
    }
  }
}
</style>
